module.exports = __webpack_public_path__ + "media/images/services/thumbnail/wedding-100x100-6671ace449ba1e1df4c158088bdeb8e3.jpg";